import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "./NotificationAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* updatedNotificationsRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updatedNotifications, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* sendNotificationRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.sendNotification, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* sendCustomNotificationRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.sendCustomNotification, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getListOfNotificationsRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getListOfNotifications, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getListOfFeedbackRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getListOfFeedback, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getListOfPrayerRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getListOfPrayer, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteNotificationRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteNotification, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* NotificationWatcherSaga() {
  yield takeLatest(
    actionTypes.GET_USERS_FOR_NOTIFICATIONS_REQUEST,
    updatedNotificationsRequestSaga
  );

  yield takeLatest(actionTypes.SEND_CUSTOM_NOTIFICATION_REQUEST, sendCustomNotificationRequestSaga);

  yield takeLatest(actionTypes.SEND_NOTIFICATION_REQUEST, sendNotificationRequestSaga);

  yield takeEvery(actionTypes.GET_LIST_OF_NOTIFICATIONS_REQEST, getListOfNotificationsRequestSaga);

  yield takeLatest(actionTypes.GET_LIST_OF_FEEDBACK_REQEST, getListOfFeedbackRequestSaga);

  yield takeLatest(actionTypes.GET_LIST_OF_PRAYER_REQEST, getListOfPrayerRequestSaga);

  yield takeLatest(actionTypes.DELETE_NOTIFICATION_REQUEST, deleteNotificationRequestSaga);
}
